
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["transition duration-300 ease-in-out delay-150",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1440 600","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",attrs:{"d":"M0 600V150c97.426 1.579 194.852 3.158 291 7s191.02 9.947 278 6c86.98-3.947 166.072-17.947 252-29s178.694-19.158 283-16c104.306 3.158 220.153 17.579 336 32v450z","fill":"#726da866"}}),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",attrs:{"d":"M0 600V300c97.407-5.713 194.813-11.426 289 4 94.187 15.426 185.153 51.99 274 51 88.847-.99 175.574-39.536 272-55 96.426-15.464 202.55-7.847 305-4 102.45 3.847 201.225 3.923 300 4v300z","fill":"#726da888"}}),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",attrs:{"d":"M0 600V450c108.995-8.067 217.99-16.134 294-17 76.01-.866 119.033 5.469 229-5 109.967-10.469 286.876-37.742 394-26 107.124 11.742 144.464 62.498 220 77 75.536 14.502 189.268-7.249 303-29v150z","fill":"#726da8ff"}})])
          )
        }
      }
    